<template>
  <b-card no-body v-if="conversions">
    <b-tabs card justified>
      <b-card-header>
        <b-row class="mt-3">
          <b-col md="8">
            <label class="form-control-label">Date Range</label>
            <b-input-group>
              <template #prepend>
                <b-dropdown variant="outline-danger">
                  <template #button-content>
                    {{ rangeTitle }}
                  </template>
                  <b-dropdown-item v-for="item in ranges" :key="item.value" @click="range = item.value">{{ item.label }}</b-dropdown-item>
                </b-dropdown>
              </template>
              <b-form-datepicker v-model="start_date" locale="en" :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"></b-form-datepicker>
              <b-form-datepicker v-model="end_date" locale="en" :min="start_date" :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit' }"></b-form-datepicker>
            </b-input-group>
          </b-col>
        </b-row>
      </b-card-header>
      <b-tab title="Listings" active>
        <b-row>
          <b-col md="6">
            <base-input label="View By" sr-only-label label-for="viewBy" placeholder="Select an Conversion">
              <el-select v-model="viewBy">
                <el-option v-for="view in views"
                           :key="view.value"
                           :label="view.label"
                           :value="view.value">
                </el-option>
              </el-select>
            </base-input>
          </b-col>
        </b-row>
        <b-card-text>
          <b-row>
            <b-col md="6">
              <b-card no-body>
                <b-card-header><h3 class="mb-0">Contacts to Listing Appointments Set</h3></b-card-header>
                <b-table responsive small :items="conversions.listing_contacts_set" :fields="listingApptsSetVisible" foot-clone>
                  <template #cell(name)="row">
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-sm rounded-circle mr-3">
                        <img :alt="row.item.name + ' avatar'" :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + row.item.avatar">
                      </span>
                      <span>{{ row.item.name }}</span>
                    </div>
                  </template>
                  <template #cell(conversion)="row">
                    <span v-if="row.item.listings_set == 0 || row.item.contacts == 0">0%</span>
                    <span v-else>{{ (row.item.listings_set / row.item.contacts * 100).toFixed(2) }}%</span>
                  </template>
                  <template #cell(ratio)="row">
                    {{ calculateRatio(row.item.contacts, row.item.listings_set) }}
                  </template>

                  <!-- Footer -->
                  <template #foot(name)="row">
                    Totals:
                  </template>
                  <template #foot(contacts)="row">
                    {{ totalContacts }}
                  </template>
                  <template #foot(listings_set)="row">
                    {{ totalListingsSet }}
                  </template>
                  <template #foot(conversion)="row">
                    <span v-if="totalListingsSet == 0 || totalContacts == 0">0%</span>
                    <span v-else>{{ (totalListingsSet / totalContacts * 100).toFixed(2) }}%</span>
                  </template>
                  <template #foot(ratio)="row">
                    {{ calculateRatio(totalContacts, totalListingsSet) }}
                  </template>
                </b-table>
              </b-card>
            </b-col>
            <b-col md="6">
              <b-card no-body>
                <b-card-header><h3 class="mb-0">Listing Appointments Set to Held</h3></b-card-header>
                <b-table responsive small :items="conversions.listings_set_held" :fields="listingsSetHeldVisible" foot-clone>
                  <template #cell(name)="row">
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-sm rounded-circle mr-3">
                        <img :alt="row.item.name + ' avatar'" :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + row.item.avatar">
                      </span>
                      <span>{{ row.item.name }}</span>
                    </div>
                  </template>
                  <template #cell(conversion)="row">
                    <span v-if="row.item.listings_set == 0 || row.item.listings_held == 0">0%</span>
                    <span v-else>{{ (row.item.listings_held / row.item.listings_set * 100).toFixed(2) }}%</span>
                  </template>
                  <template #cell(ratio)="row">
                    {{ calculateRatio(row.item.listings_set, row.item.listings_held) }}
                  </template>

                  <!-- Footer -->
                  <template #foot(name)="row">
                    Totals:
                  </template>
                  <template #foot(listings_set)="row">
                    {{ totalListingsSet }}
                  </template>
                  <template #foot(listings_held)="row">
                    {{ totalListingsHeld }}
                  </template>
                  <template #foot(conversion)="row">
                    <span v-if="totalListingsHeld == 0 || totalListingsSet == 0">0%</span>
                    <span v-else>{{ (totalListingsHeld / totalListingsSet * 100).toFixed(2) }}%</span>
                  </template>
                  <template #foot(ratio)="row">
                    {{ calculateRatio(totalListingsSet, totalListingsHeld) }}
                  </template>
                </b-table>
              </b-card>
            </b-col>
            <b-col md="6">
              <b-card no-body>
                <b-card-header><h3 class="mb-0">Listing Appointments Held to Taken</h3></b-card-header>
                <b-table responsive small :items="conversions.listings_held_taken" :fields="listingsHeldTakenVisible" foot-clone>
                  <template #cell(name)="row">
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-sm rounded-circle mr-3">
                        <img :alt="row.item.name + ' avatar'" :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + row.item.avatar">
                      </span>
                      <span>{{ row.item.name }}</span>
                    </div>
                  </template>
                  <template #cell(conversion)="row">
                    <span v-if="row.item.listings_taken == 0 || row.item.listings_held == 0">0%</span>
                    <span v-else>{{ (row.item.listings_taken / row.item.listings_held * 100).toFixed(2) }}%</span>
                  </template>
                  <template #cell(ratio)="row">
                    {{ calculateRatio(row.item.listings_held, row.item.listings_taken) }}
                  </template>

                  <!-- Footer -->
                  <template #foot(name)="row">
                    Totals:
                  </template>
                  <template #foot(listings_held)="row">
                    {{ totalListingsHeld }}
                  </template>
                  <template #foot(listings_taken)="row">
                    {{ totalListingsTaken }}
                  </template>
                  <template #foot(conversion)="row">
                    <span v-if="totalListingsTaken == 0 || totalListingsHeld == 0">0%</span>
                    <span v-else>{{ (totalListingsTaken / totalListingsHeld * 100).toFixed(2) }}%</span>
                  </template>
                  <template #foot(ratio)="row">
                    {{ calculateRatio(totalListingsHeld, totalListingsTaken) }}
                  </template>
                </b-table>
              </b-card>
            </b-col>
            <b-col md="6">
              <b-card no-body>
                <b-card-header><h3 class="mb-0">Listing Appointments Taken to Pended</h3></b-card-header>
                <b-table responsive small :items="conversions.listings_taken_sold" :fields="listingsTakenSoldVisible" foot-clone>
                  <template #cell(name)="row">
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-sm rounded-circle mr-3">
                        <img :alt="row.item.name + ' avatar'" :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + row.item.avatar">
                      </span>
                      <span>{{ row.item.name }}</span>
                    </div>
                  </template>
                  <template #cell(conversion)="row">
                    <span v-if="row.item.listings_sold == 0 || row.item.listings_Taken == 0">0%</span>
                    <span v-else>{{ (row.item.listings_sold / row.item.listings_taken * 100).toFixed(2) }}%</span>
                  </template>
                  <template #cell(ratio)="row">
                    {{ calculateRatio(row.item.listings_taken, row.item.listings_sold) }}
                  </template>

                  <!-- Footer -->
                  <template #foot(name)="row">
                    Totals:
                  </template>
                  <template #foot(listings_taken)="row">
                    {{ totalListingsTaken }}
                  </template>
                  <template #foot(listings_sold)="row">
                    {{ totalListingsSold }}
                  </template>
                  <template #foot(conversion)="row">
                    <span v-if="totalListingsTaken == 0 || totalListingsSold == 0">0%</span>
                    <span v-else>{{ (totalListingsSold / totalListingsTaken * 100).toFixed(2) }}%</span>
                  </template>
                  <template #foot(ratio)="row">
                    {{ calculateRatio(totalListingsTaken, totalListingsSold) }}
                  </template>
                </b-table>
              </b-card>
            </b-col>
          </b-row>
        </b-card-text>
      </b-tab>
      <b-tab title="Buyers">
        <b-row>
          <b-col md="6">
            <base-input label="View By" sr-only-label label-for="viewBy" placeholder="Select an Conversion">
              <el-select v-model="viewBy">
                <el-option v-for="view in views"
                           :key="view.value"
                           :label="view.label"
                           :value="view.value">
                </el-option>
              </el-select>
            </base-input>
          </b-col>
        </b-row>
        <b-card-text>
          <b-row>
            <b-col md="6">
              <b-card no-body>
                <b-card-header><h3 class="mb-0">Contacts to Buyer Appointments Set</h3></b-card-header>
                <b-table responsive small :items="conversions.buyer_contacts_set" :fields="buyerApptsSetVisible" foot-clone>
                  <template #cell(name)="row">
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-sm rounded-circle mr-3">
                        <img :alt="row.item.name + ' avatar'" :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + row.item.avatar">
                      </span>
                      <span>{{ row.item.name }}</span>
                    </div>
                  </template>
                  <template #cell(conversion)="row">
                    <span v-if="row.item.buyers_set == 0 || row.item.contacts == 0">0%</span>
                    <span v-else>{{ (row.item.buyers_set / row.item.contacts * 100).toFixed(2) }}%</span>
                  </template>
                  <template #cell(ratio)="row">
                    {{ calculateRatio(row.item.contacts, row.item.buyers_set) }}
                  </template>

                  <!-- Footer -->
                  <template #foot(name)="row">
                    Totals:
                  </template>
                  <template #foot(contacts)="row">
                    {{ totalContacts }}
                  </template>
                  <template #foot(buyers_set)="row">
                    {{ totalBuyersSet }}
                  </template>
                  <template #foot(conversion)="row">
                    <span v-if="totalBuyersSet == 0 || totalContacts == 0">0%</span>
                    <span v-else>{{ (totalBuyersSet / totalContacts * 100).toFixed(2) }}%</span>
                  </template>
                  <template #foot(ratio)="row">
                    {{ calculateRatio(totalContacts, totalBuyersSet) }}
                  </template>
                </b-table>
              </b-card>
            </b-col>
            <b-col md="6">
              <b-card no-body>
                <b-card-header><h3 class="mb-0">Buyer Appointments Set to Held</h3></b-card-header>
                <b-table responsive small :items="conversions.buyers_set_held" :fields="buyersSetHeldVisible" foot-clone>
                  <template #cell(name)="row">
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-sm rounded-circle mr-3">
                        <img :alt="row.item.name + ' avatar'" :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + row.item.avatar">
                      </span>
                      <span>{{ row.item.name }}</span>
                    </div>
                  </template>
                  <template #cell(conversion)="row">
                    <span v-if="row.item.buyers_held == 0 || row.item.buyers_set == 0">0%</span>
                    <span v-else>{{ (row.item.buyers_held / row.item.buyers_set * 100).toFixed(2) }}%</span>
                  </template>
                  <template #cell(ratio)="row">
                    {{ calculateRatio(row.item.buyers_set, row.item.buyers_held) }}
                  </template>

                  <!-- Footer -->
                  <template #foot(name)="row">
                    Totals:
                  </template>
                  <template #foot(buyers_set)="row">
                    {{ totalBuyersSet }}
                  </template>
                  <template #foot(buyers_held)="row">
                    {{ totalBuyersHeld }}
                  </template>
                  <template #foot(conversion)="row">
                    <span v-if="totalBuyersHeld == 0 || totalBuyersSet == 0">0%</span>
                    <span v-else>{{ (totalBuyersHeld / totalBuyersSet * 100).toFixed(2) }}%</span>
                  </template>
                  <template #foot(ratio)="row">
                    {{ calculateRatio(totalBuyersSet, totalBuyersHeld) }}
                  </template>
                </b-table>
              </b-card>
            </b-col>
            <b-col md="6">
              <b-card no-body>
                <b-card-header><h3 class="mb-0">Buyer Appointments Held to Signed</h3></b-card-header>
                <b-table responsive small :items="conversions.buyers_held_signed" :fields="buyersHeldSignedVisible" foot-clone>
                  <template #cell(name)="row">
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-sm rounded-circle mr-3">
                        <img :alt="row.item.name + ' avatar'" :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + row.item.avatar">
                      </span>
                      <span>{{ row.item.name }}</span>
                    </div>
                  </template>
                  <template #cell(conversion)="row">
                    <span v-if="row.item.buyers_signed == 0 || row.item.buyers_held == 0">0%</span>
                    <span v-else>{{ (row.item.buyers_signed / row.item.buyers_held * 100).toFixed(2) }}%</span>
                  </template>
                  <template #cell(ratio)="row">
                    {{ calculateRatio(row.item.buyers_held, row.item.buyers_signed) }}
                  </template>

                  <!-- Footer -->
                  <template #foot(name)="row">
                    Totals:
                  </template>
                  <template #foot(buyers_held)="row">
                    {{ totalBuyersHeld }}
                  </template>
                  <template #foot(buyers_signed)="row">
                    {{ totalBuyersSigned }}
                  </template>
                  <template #foot(conversion)="row">
                    <span v-if="totalBuyersSigned == 0 || totalBuyersHeld == 0">0%</span>
                    <span v-else>{{ (totalBuyersSigned / totalBuyersHeld * 100).toFixed(2) }}%</span>
                  </template>
                  <template #foot(ratio)="row">
                    {{ calculateRatio(totalBuyersHeld, totalBuyersSigned) }}
                  </template>
                </b-table>
              </b-card>
            </b-col>
            <b-col md="6">
              <b-card no-body>
                <b-card-header><h3 class="mb-0">Buyer Appointments Taken to Pended</h3></b-card-header>
                <b-table responsive small :items="conversions.buyers_taken_sold" :fields="buyersSignedSoldVisible" foot-clone>
                  <template #cell(name)="row">
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-sm rounded-circle mr-3">
                        <img :alt="row.item.name + ' avatar'" :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + row.item.avatar">
                      </span>
                      <span>{{ row.item.name }}</span>
                    </div>
                  </template>
                  <template #cell(conversion)="row">
                    <span v-if="row.item.buyers_sold == 0 || row.item.buyers_signed == 0">0%</span>
                    <span v-else>{{ (row.item.buyers_sold / row.item.buyers_signed * 100).toFixed(2) }}%</span>
                  </template>
                  <template #cell(ratio)="row">
                    {{ calculateRatio(row.item.buyers_signed, row.item.buyers_sold) }}
                  </template>

                  <!-- Footer -->
                  <template #foot(name)="row">
                    Totals:
                  </template>
                  <template #foot(buyers_signed)="row">
                    {{ totalBuyersSigned }}
                  </template>
                  <template #foot(buyers_sold)="row">
                    {{ totalBuyersSold }}
                  </template>
                  <template #foot(conversion)="row">
                    <span v-if="totalBuyersSold == 0 || totalBuyersSigned == 0">0%</span>
                    <span v-else>{{ (totalBuyersSold / totalBuyersSigned * 100).toFixed(2) }}%</span>
                  </template>
                  <template #foot(ratio)="row">
                    {{ calculateRatio(totalBuyersSigned, totalBuyersSold) }}
                  </template>
                </b-table>
              </b-card>
            </b-col>
          </b-row>
        </b-card-text>
      </b-tab>
      <b-tab title="Conversions">
        <b-row>
          <b-col md="6">
            <base-input label="View By" sr-only-label label-for="viewBy" placeholder="Select an Conversion">
              <el-select v-model="viewBy">
                <el-option v-for="view in views"
                           :key="view.value"
                           :label="view.label"
                           :value="view.value">
                </el-option>
              </el-select>
            </base-input>
          </b-col>
        </b-row>
        <b-card-text>
          <b-row>
            <b-col>
              <b-card no-body>
                <b-card-header><h3 class="mb-0">Dials to Contacts</h3></b-card-header>
                <b-table responsive small :items="conversions.dials_contacts" :fields="dialsContactsVisible" foot-clone>
                  <template #cell(name)="row">
                    <div class="d-flex align-items-center">
                      <span class="avatar avatar-sm rounded-circle mr-3">
                        <img :alt="row.item.name + ' avatar'" :src="'https://vapor-us-east-1-1603342423.s3.amazonaws.com/' + row.item.avatar">
                      </span>
                      <span>{{ row.item.name }}</span>
                    </div>
                  </template>
                  <template #cell(conversion)="row">
                    <span v-if="row.item.dials == 0 || row.item.contacts == 0">0%</span>
                    <span v-else>{{ (row.item.contacts / row.item.dials * 100).toFixed(2) }}%</span>
                  </template>
                  <template #cell(ratio)="row">
                    {{ calculateRatio(row.item.contacts, row.item.dials) }}
                  </template>

                  <!-- Footer -->
                  <template #foot(name)="row">
                    Totals:
                  </template>
                  <template #foot(dials)="row">
                    {{ totalDials }}
                  </template>
                  <template #foot(contacts)="row">
                    {{ totalContacts }}
                  </template>
                  <template #foot(conversion)="row">
                    <span v-if="totalDials == 0 || totalContacts == 0">0%</span>
                    <span v-else>{{ (totalContacts / totalDials * 100).toFixed(2) }}%</span>
                  </template>
                  <template #foot(ratio)="row">
                    {{ calculateRatio(totalContacts, totalDials) }}
                  </template>
                </b-table>
              </b-card>
            </b-col>
          </b-row>
        </b-card-text>
      </b-tab>
      <b-tab title="Custom Tracking Sources">
        <b-card-text>
          <tracking-sources-reports :userRoute="userRoute" :start_date="start_date" :end_date="end_date" :range="range" :rangeTitle="rangeTitle"></tracking-sources-reports>
        </b-card-text>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import axios from 'axios';
import {Select, Option} from 'element-ui';
import errorsMixin from '@/mixins/errors-mixin';
import conversionsMixin from '@/mixins/conversions-mixin';
import TrackingSourcesReports from './TrackingSourcesReports'

export default {
  mixins: [errorsMixin, conversionsMixin],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    TrackingSourcesReports
  },
  props: {
    userRoute: null
  },
  data() {
    return {
      conversions: null,
      start_date: new Date(new Date().getFullYear(), 0, 1),
      end_date: new Date(new Date().getFullYear(), 11, 31),
      range: 0,
      ranges: [
        { value: 0, label: "Current Year" },
        { value: 1, label: "Yesterday" },
        { value: 2, label: "Last 7 Days" },
        { value: 3, label: "Current Month" },
        { value: 4, label: "Last 3 Months" },
      ],
      viewBy: 'conversion',
      views: [
        { value: 'conversion', label: "Conversion %" },
        { value: 'ratio', label: "Ratio" },
      ]
    }
  },
  computed: {
    rangeTitle() {
      return this.ranges.filter((item) => {
        return item.value == this.range;
      })[0].label;
    },
    totalDials() {
      return this.conversions.dials_contacts.reduce(function (total, value) {
        return total + Number(value.dials);
      }, 0);
    },
    totalContacts() {
      return this.conversions.dials_contacts.reduce(function (total, value) {
        return total + Number(value.contacts);
      }, 0);
    },
    totalListingsSet() {
      return this.conversions.listing_contacts_set.reduce(function (total, value) {
        return total + Number(value.listings_set);
      }, 0);
    },
    totalBuyersSet() {
      return this.conversions.buyer_contacts_set.reduce(function (total, value) {
        return total + Number(value.buyers_set);
      }, 0);
    },
    totalListingsHeld() {
      return this.conversions.listings_set_held.reduce(function (total, value) {
        return total + Number(value.listings_held);
      }, 0);
    },
    totalBuyersHeld() {
      return this.conversions.buyers_set_held.reduce(function (total, value) {
        return total + Number(value.buyers_held);
      }, 0);
    },
    totalListingsTaken() {
      return this.conversions.listings_held_taken.reduce(function (total, value) {
        return total + Number(value.listings_taken);
      }, 0);
    },
    totalBuyersSigned() {
      return this.conversions.buyers_held_signed.reduce(function (total, value) {
        return total + Number(value.buyers_signed);
      }, 0);
    },
    totalListingsSold() {
      return this.conversions.listings_taken_sold.reduce(function (total, value) {
        return total + Number(value.listings_sold);
      }, 0);
    },
    totalBuyersSold() {
      return this.conversions.buyers_taken_sold.reduce(function (total, value) {
        return total + Number(value.buyers_sold);
      }, 0);
    },
    dialsContactsVisible() {
      return this.dialsContactsFields.filter(field => field.visible);
    },
    listingApptsSetVisible() {
      return this.listingApptsSetFields.filter(field => field.visible);
    },
    buyerApptsSetVisible() {
      return this.buyerApptsSetFields.filter(field => field.visible);
    },
    listingsSetHeldVisible() {
      return this.listingsSetHeldFields.filter(field => field.visible);
    },
    buyersSetHeldVisible() {
      return this.buyersSetHeldFields.filter(field => field.visible);
    },
    listingsHeldTakenVisible() {
      return this.listingsHeldTakenFields.filter(field => field.visible);
    },
    buyersHeldSignedVisible() {
      return this.buyersHeldSignedFields.filter(field => field.visible);
    },
    listingsTakenSoldVisible() {
      return this.listingsTakenSoldFields.filter(field => field.visible);
    },
    buyersSignedSoldVisible() {
      return this.buyersSignedSoldFields.filter(field => field.visible);
    }
  },
  methods: {
    async getConversions() {
      let startDate = new Date(this.start_date).toLocaleDateString("en-US");
      let endDate = new Date(this.end_date).toLocaleDateString("en-US");

      axios.get(this.userRoute + '/reports/conversions?start_date=' + startDate + '&end_date=' + endDate)
      .then(response => {
        this.conversions = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    updateRange() {
      switch(this.range) {
        case 0:
          this.start_date = new Date(new Date().getFullYear(), 0, 1);
          this.end_date = new Date(new Date().getFullYear(), 11, 31);
          break;
        case 1:
          var date = new Date();
          var start_date = new Date(date.setDate(date.getDate() - 1))
          this.start_date = start_date;
          this.end_date = start_date;
          break;
        case 2:
          var date = new Date();
          var start_date = new Date(date.setDate(date.getDate() - 7))
          this.start_date = start_date;
          this.end_date = new Date();
          break;
        case 3:
          var date = new Date();
          var start_date = new Date(date.setDate(date.getDate() - date.getDate() + 1))
          this.start_date = start_date;
          this.end_date = new Date();
          break;
        case 4:
          var date = new Date();
          var start_date = new Date(date.setDate(date.getDate() - 84))
          this.start_date = start_date;
          this.end_date = new Date();
          break;
        default:
          this.start_date = new Date(new Date().getFullYear(), 0, 1);
          this.end_date = new Date(new Date().getFullYear(), 11, 31);
      }
    },
    calculateRatio(num1, num2) {
      if(num1 == 0 || num2 == 0) {
        return 0;
      }

      if(num1 == num2) {
        return '1:1';
      }

      if(num1 > num2) {
        let ratio = num1 / num2;
        if(!Number.isInteger(ratio)) {
          ratio = ratio.toFixed(1) 
        }
        return ratio + ':' + '1';
      } else {
        let ratio = num2 / num1;
        if(!Number.isInteger(ratio)) {
          ratio = ratio.toFixed(1) 
        }
        return '1' + ':' + ratio;
      }
    },
    toggleFields() {
      const fields = [this.dialsContactsFields, this.listingApptsSetFields, this.buyerApptsSetFields, this.listingsSetHeldFields, this.buyersSetHeldFields, this.listingsHeldTakenFields, this.buyersHeldSignedFields, this.listingsTakenSoldFields, this.buyersSignedSoldFields];

      fields.forEach((field) => {
        field.filter((field) => {
          if(field.key == 'conversion' || field.key == 'ratio') {
            field.visible = !field.visible;
          }
        });
      });
    }
  },
  created() {
    this.getConversions();
  },
  watch: {
    range(to, from) {
      this.updateRange();
    },
    start_date(to, from) {
      this.getConversions();
    },
    end_date(to, from) {
      this.getConversions();
    },
    viewBy(to, from) {
      this.toggleFields();
    }
  }
};
</script>
<style lang="scss">
  .nav-tabs .nav-link {
    text-transform: uppercase;
    color: #000000;
    border: 0px;
    &:hover {
      color: #dc3545;
    }
    &.active {
      font-weight: bold;
      background: none;
      border-bottom: 3px solid #dc3545;
      color: #dc3545;
    }
  }
</style>